import { Status } from '../../constants/status';
import { strings } from '../../utils/strings';

export const statusesData = {
  [Status.unsaved]: {
    buttons: [
      {
        name: 'submit for Approval',
        target: Status.applied_c,
        id: 'submit_for_approval',
      },
      {
        name: 'Save as Draft',
        target: Status.draft_by_lender,
        id: 'save_draft',
        isLinkButton: true,
      },
    ],
    isNewForm: true,
  },
  [Status.draft_by_lender]: {
    buttons: [
      {
        name: 'submit for Approval',
        target: Status.applied_c,
        id: 'submit_for_approval_2',
      },
      {
        name: 'Delete Draft',
        target: Status.deleted,
        color: 'primary',
        id: 'delete',
        isLinkButton: true,
      },
    ],
  },
  [Status.listed]: {
    buttons: [
      {
        name: 'Reclaim',
        target: Status.claiming_c,
        color: 'primary',
        id: 'claiming',
      },
      {
        name: 'Donate/Recycle',
        target: Status.for_donation,
        color: 'primary',
        id: 'for_donation',
      },
    ],
  },

  [Status.approved1_c]: {
    title: 'APPROVED',
    buttons: [
      {
        name: strings.item_shipped,
        target: Status.shipped_c,
        color: 'primary',
        id: 'item_was_shipped',
      },
    ],
  },

  [Status.rejected1_c]: {
    title: 'Rejected 1',
    buttons: [
      {
        name: 'Delete',
        target: Status.deleted,
        color: 'primary',
        id: 'delete',
      },
    ],
  },

  [Status.rejected2_c]: {
    title: 'Rejected 2',
    buttons: [
      {
        name: 'Reclaim',
        target: Status.claiming_c,
        color: 'primary',
        id: 'claiming',
      },
      {
        name: 'Donate/Recycle',
        target: Status.for_donation,
        color: 'primary',
        id: 'for_donation',
      },
    ],
  },

  [Status.returning_c]: {
    title: 'Rejected 1',
    buttons: [
      {
        name: 'Item Received',
        target: Status.returned_c,
        color: 'primary',
        id: 'item_received',
      },
    ],
  },

  [Status.applied_c]: {
    buttons: [
      {
        name: 'withdraw application',
        target: Status.withdrawn_c2,
        color: 'primary',
        id: 'withdraw_application',
      },
    ],
    title: 'APPLIED',
  },
};
